import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {NotificationsPanelProps} from '@Panels/notifications-panel/notifications-panel.types';

export const NOTIFICATIONS_PANEL_ID = 'notifications-panel-id';

export const openNotificationsModal = (props: NotificationsPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.NOTIFICATIONS_MODAL,
      panelProps: props,
    })
  );
};
